import { TLD } from "./urls"

export const COOKIE_DOMAIN = `.gobble.${TLD}`
export const COOKIE_PATH = "/"
export const PROMO_CODE_COOKIE = "promo_code"
